import React from 'react'
import styled from 'styled-components'

import { SvgIconComponent } from 'components/Luxkit/SvgIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { TypographyElement } from 'components/Luxkit/Typography/Typography'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const NoOverFlowBodyTextBlock = styled(BodyTextBlock)`
  ${TypographyElement} {
    overflow-wrap: anywhere;
  }
`

interface Props {
  icon: SvgIconComponent
  hideIconForMobile?: boolean
}

function ItemTitle({
  icon: Icon,
  hideIconForMobile = false,
  children,
}: React.PropsWithChildren<Props>) {
  const titleProps: React.ComponentProps<typeof NoOverFlowBodyTextBlock> = {
    variant: 'medium',
    weight: 'bold',
    lineClamp: 2,
    wrap: 'pretty',
    children,
  }

  if (hideIconForMobile) {
    return (
      <>
        <CSSBreakpoint max="mobile">
          <NoOverFlowBodyTextBlock {...titleProps} />
        </CSSBreakpoint>
        <CSSBreakpoint min="tablet">
          <NoOverFlowBodyTextBlock
            {...titleProps}
            startIcon={<Icon size="S" />}
          />
        </CSSBreakpoint>
      </>
    )
  }

  return (
    <NoOverFlowBodyTextBlock {...titleProps} startIcon={<Icon size="S" />} />
  )
}

export default ItemTitle
